var Handlebars = require('/Users/najeeb/Applications/Project/starzhtml5player/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"bitdash-settings bitdash-settings--seasons\">\n\n    <ul id=\"SERIES_LIST\" class=\"seasonSel\">\n\n    </ul>\n\n    <a href=\"#\" id=\"CHAPTER_UP\" class=\"chapter-button\"><span class=\"icon-arrow-up\"></span></a>\n\n    <div id=\"CHAPTER_SCROLLABLE\" class=\"chapter-module\">\n        <ul id=\"CHAPTERS_LIST\" class=\"chapter-list\">\n\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"_episodes"),depth0,{"name":"_episodes","data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "        </ul>\n    </div>\n\n    <a href=\"#\" id=\"CHAPTER_DOWN\" class=\"chapter-button\"><span class=\"icon-arrow-down\"></span></a>\n\n</div>\n";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/modules/episode_selector/episode_selector.hbs
// module id = 417
// module chunks = 0